export const logoPath = "assets/img/logo.png";
